/* Couve Cards — minimal, progressive. */
(function(){
  document.documentElement.classList.add('cc-js');
  var openers=document.querySelectorAll('[data-cc-search-open]');
  var drawer=document.querySelector('[data-cc-search]');
  if(drawer){
    openers.forEach(function(b){b.addEventListener('click',function(){drawer.setAttribute('open','');var i=drawer.querySelector('input[name="q"]');if(i)i.focus();});});
    drawer.addEventListener('click',function(e){if(e.target===drawer)drawer.removeAttribute('open');});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')drawer.removeAttribute('open');});
  }
  // Product gallery: one panel per media item, so videos play in place.
  // A playing video is paused when you switch away from its panel.
  var gal=document.querySelector('[data-cc-gallery]');
  if(gal){
    var panels=gal.querySelectorAll('[data-cc-gallery-panel]');
    var thumbs=gal.querySelectorAll('[data-cc-thumb]');
    function showPanel(index){
      panels.forEach(function(panel){
        var on=panel.getAttribute('data-index')===index;
        if(on)panel.removeAttribute('data-cc-gallery-off');
        else{
          // Only the panel we are leaving needs stopping — resetting every
          // hidden iframe on each switch would refetch them all.
          if(!panel.hasAttribute('data-cc-gallery-off')){
            panel.querySelectorAll('video').forEach(function(v){if(!v.paused)v.pause();});
            panel.querySelectorAll('iframe').forEach(function(f){f.src=f.src;});
          }
          panel.setAttribute('data-cc-gallery-off','');
        }
      });
      thumbs.forEach(function(b){b.setAttribute('aria-current',b.getAttribute('data-index')===index?'true':'false');});
    }
    thumbs.forEach(function(btn){
      btn.addEventListener('click',function(){showPanel(btn.getAttribute('data-index'));});
    });
  }
  // Video facades on the personal collection: the embed only loads on click.
  document.querySelectorAll('[data-cc-video]').forEach(function(box){
    var btn=box.querySelector('[data-cc-video-play]');
    if(!btn)return;
    btn.addEventListener('click',function(){
      var src=box.getAttribute('data-cc-video-src');
      if(!src)return;
      var frame=document.createElement('iframe');
      frame.src=src+(src.indexOf('?')===-1?'?':'&')+'autoplay=1';
      frame.title=box.getAttribute('data-cc-video-title')||'Video';
      frame.allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      frame.setAttribute('allowfullscreen','');
      btn.replaceWith(frame);
    });
  });
  // Facets: auto-submit, independent collapses (all closed on load),
  // and See all → dialog with the same checklist (top-N stays in the sidebar).
  var facets=document.querySelector('[data-cc-facets]');
  if(facets){
    function facetItems(facet){return facet.querySelectorAll('[data-cc-facet-item]');}
    function facetNeedle(facet, fromInput){
      if(fromInput)return fromInput.value.trim().toLowerCase();
      var needle='';
      facet.querySelectorAll('[data-cc-facet-q]').forEach(function(q){
        if(q.value.trim())needle=q.value.trim().toLowerCase();
      });
      return needle;
    }
    function filterFacetList(facet, fromInput){
      var needle=facetNeedle(facet, fromInput);
      if(needle)facet.setAttribute('data-cc-filtering','');
      else facet.removeAttribute('data-cc-filtering');
      var shown=0;
      facetItems(facet).forEach(function(li){
        var label=li.getAttribute('data-label')||'';
        var keep=!needle||label.indexOf(needle)!==-1;
        li.hidden=!keep;
        if(keep)li.classList.remove('is-mismatch');
        else li.classList.add('is-mismatch');
        if(keep)shown++;
      });
      facet.querySelectorAll('[data-cc-facet-empty]').forEach(function(empty){
        empty.hidden=shown>0;
      });
    }
    function syncFacetSummary(facet){
      var summary=facet.querySelector('[data-cc-facet-summary]');
      if(!summary)return;
      var labels=[];
      facet.querySelectorAll('input[type="checkbox"]:checked').forEach(function(box){
        var span=box.parentElement&&box.parentElement.querySelector('span');
        if(span&&span.textContent)labels.push(span.textContent.trim());
      });
      var price=facet.querySelector('.cc-facet__price');
      if(price){
        var inputs=price.querySelectorAll('input');
        var min=inputs[0]&&inputs[0].value;
        var max=inputs[1]&&inputs[1].value;
        summary.hidden=!(min||max);
        return;
      }
      if(!labels.length){summary.hidden=true;summary.textContent='';return;}
      summary.hidden=false;
      summary.innerHTML='';
      labels.slice(0,2).forEach(function(text){
        var chip=document.createElement('span');
        chip.className='cc-facet__chip';
        chip.textContent=text;
        summary.appendChild(chip);
      });
      if(labels.length>2){
        var more=document.createElement('span');
        more.className='cc-facet__more';
        more.textContent='+'+(labels.length-2);
        summary.appendChild(more);
      }
    }
    facets.addEventListener('change',function(e){
      if(e.target&&e.target.hasAttribute('data-cc-facet-q'))return;
      var facet=e.target&&e.target.closest('[data-cc-facet]');
      if(facet)syncFacetSummary(facet);
      facets.submit();
    });
    facets.querySelectorAll('[data-cc-facet]').forEach(function(facet){
      var toggle=facet.querySelector('.cc-facet__toggle');
      if(toggle){
        toggle.addEventListener('click',function(){
          var open=facet.classList.toggle('is-open');
          toggle.setAttribute('aria-expanded',open?'true':'false');
        });
      }
      var dialog=facet.querySelector('[data-cc-facet-dialog]');
      var list=facet.querySelector('[data-cc-facet-list]');
      var slot=facet.querySelector('[data-cc-facet-dialog-body]');
      var home=list&&list.parentNode;
      var searches=facet.querySelectorAll('[data-cc-facet-q]');
      function restoreList(){
        facet.removeAttribute('data-cc-open');
        facet.removeAttribute('data-cc-filtering');
        if(list&&home&&list.parentNode!==home){
          var marker=home.querySelector('[data-cc-facet-empty], [data-cc-facet-all]');
          if(marker)home.insertBefore(list,marker);
          else home.appendChild(list);
        }
        searches.forEach(function(q){q.value='';});
        facetItems(facet).forEach(function(li){
          li.hidden=false;
          li.classList.remove('is-mismatch');
        });
        facet.querySelectorAll('[data-cc-facet-empty]').forEach(function(empty){empty.hidden=true;});
      }
      if(dialog){
        dialog.addEventListener('close',restoreList);
        dialog.addEventListener('click',function(e){if(e.target===dialog)dialog.close();});
        var opener=facet.querySelector('[data-cc-facet-all]');
        if(opener){
          opener.addEventListener('click',function(){
            if(!dialog.showModal)return;
            facet.setAttribute('data-cc-open','');
            if(list&&slot)slot.appendChild(list);
            var sidebarQ=facet.querySelector('.cc-facet__body [data-cc-facet-q]');
            var dialogQ=dialog.querySelector('[data-cc-facet-q]');
            if(sidebarQ&&dialogQ&&sidebarQ.value&&!dialogQ.value)dialogQ.value=sidebarQ.value;
            dialog.showModal();
            filterFacetList(facet, dialogQ||sidebarQ);
            if(dialogQ)dialogQ.focus();
            else if(sidebarQ)sidebarQ.focus();
          });
        }
        var closer=facet.querySelector('[data-cc-facet-close]');
        if(closer)closer.addEventListener('click',function(){dialog.close();});
      }
      searches.forEach(function(q){
        q.addEventListener('keydown',function(e){if(e.key==='Enter')e.preventDefault();});
        q.addEventListener('input',function(){filterFacetList(facet, q);});
      });
    });
    document.addEventListener('keydown',function(e){
      if(e.key!=='Escape')return;
      facets.querySelectorAll('[data-cc-facet-dialog]').forEach(function(d){if(d.open)d.close();});
    });
  }
  // Mobile disclosure: nav behind a hamburger, facets behind a Filters button.
  // The buttons ship hidden and the panels ship open, so with JS off nothing
  // collapses and everything stays reachable.
  function disclose(btn, panel, labelEl, openText, closeText){
    if(!btn||!panel)return;
    var mq=window.matchMedia('(max-width:860px)');
    function collapse(on){
      if(on){panel.setAttribute('data-collapsed','');}else{panel.removeAttribute('data-collapsed');}
      btn.setAttribute('aria-expanded',on?'false':'true');
      if(labelEl&&openText)labelEl.textContent=on?openText:closeText;
    }
    function sync(){
      btn.hidden=!mq.matches;
      if(mq.matches){collapse(true);}else{panel.removeAttribute('data-collapsed');btn.setAttribute('aria-expanded','false');if(labelEl&&openText)labelEl.textContent=openText;}
    }
    btn.addEventListener('click',function(){collapse(!panel.hasAttribute('data-collapsed'));});
    if(mq.addEventListener){mq.addEventListener('change',sync);}else if(mq.addListener){mq.addListener(sync);}
    sync();
  }
  var navBtn=document.querySelector('[data-cc-nav-toggle]');
  var navPanel=document.getElementById('cc-primary-nav');
  var navLabel=document.querySelector('[data-cc-nav-toggle-label]');
  disclose(navBtn,navPanel,navLabel,navLabel?navLabel.textContent.trim():'', 'Close');
  disclose(document.querySelector('[data-cc-filters-toggle]'),document.querySelector('[data-cc-facets-panel]'));

  // Badge placement. object-fit:contain letterboxes any photo that is not 3:4,
  // so a fixed corner offset lands the badge on background rather than on the
  // card. Measure the painted image box and offset from that instead. No JS =
  // the CSS fallback corner, which is what it was before.
  function placeBadges(){
    document.querySelectorAll('.cc-card__fig,.cc-row__fig,.cc-gallery__panel').forEach(function(fig){
      var img=fig.querySelector('img');
      if(!img)return;
      if(!img.naturalWidth||!img.naturalHeight)return;
      var w=img.clientWidth, h=img.clientHeight;
      if(!w||!h)return;
      var nat=img.naturalWidth/img.naturalHeight, box=w/h;
      var pw = nat>box ? w : h*nat;
      var ph = nat>box ? w/nat : h;
      fig.style.setProperty('--cc-badge-x', Math.round((w-pw)/2)+'px');
      fig.style.setProperty('--cc-badge-y', Math.round((h-ph)/2)+'px');
    });
  }
  placeBadges();
  window.addEventListener('load',placeBadges);
  window.addEventListener('resize',placeBadges);
  document.querySelectorAll('.cc-card__fig img,.cc-row__fig img').forEach(function(img){
    if(!img.complete)img.addEventListener('load',placeBadges);
  });

  // Quick add. The form posts to /cart/add on its own with JS off; here we
  // intercept it so the page does not navigate away from the grid, and update
  // every cart count on the page.
  function setCartCount(n){
    document.querySelectorAll('[data-cc-cart-count]').forEach(function(el){el.textContent=n;});
  }
  document.querySelectorAll('[data-cc-quickadd]').forEach(function(form){
    form.addEventListener('submit',function(e){
      if(!window.fetch)return;                       // let it post normally
      e.preventDefault();
      var btn=form.querySelector('[data-cc-quickadd-btn]');
      var label=form.querySelector('[data-cc-quickadd-label]');
      var original=label?label.textContent:'';
      if(btn)btn.disabled=true;
      fetch(form.action,{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)})
        .then(function(r){
          if(!r.ok)throw new Error('add failed');
          return fetch('/cart.js',{headers:{'Accept':'application/json'}});
        })
        .then(function(r){return r.json();})
        .then(function(cart){
          setCartCount(cart.item_count);
          if(label)label.textContent='Added';
          if(btn)btn.setAttribute('data-added','');
          setTimeout(function(){
            if(label)label.textContent=original;
            if(btn){btn.removeAttribute('data-added');btn.disabled=false;}
          },1600);
        })
        .catch(function(){ form.submit(); });        // fall back to a real post
    });
  });

  // Sticky consign CTA: after hero leaves view, until the form enters view.
  var sticky=document.querySelector('[data-cc-sticky-cta]');
  var formSec=document.querySelector('[data-cc-form-section]');
  var heroBand=document.querySelector('.cc-band');
  if(sticky&&formSec&&window.IntersectionObserver){
    var heroGone=false, formVisible=false;
    function syncSticky(){
      var show=heroGone&&!formVisible&&window.matchMedia('(max-width:860px)').matches;
      if(show)sticky.removeAttribute('hidden');else sticky.setAttribute('hidden','');
    }
    if(heroBand){
      new IntersectionObserver(function(entries){
        heroGone=!entries[0].isIntersecting;
        syncSticky();
      },{threshold:0}).observe(heroBand);
    }else{heroGone=true;}
    new IntersectionObserver(function(entries){
      formVisible=entries[0].isIntersecting;
      syncSticky();
    },{threshold:0.12}).observe(formSec);
    window.addEventListener('resize',syncSticky);
  }

  // mobile mega toggle
  document.querySelectorAll('[data-cc-mega-toggle]').forEach(function(t){
    t.addEventListener('click',function(e){
      if(window.matchMedia('(max-width:860px)').matches){
        var m=t.parentElement.querySelector('.cc-mega');
        if(m){e.preventDefault();m.style.display=m.style.display==='block'?'none':'block';}
      }
    });
  });

  // Homepage hero slider: ~5s auto-rotate, paused on hover/focus/touch,
  // off entirely under prefers-reduced-motion.
  document.querySelectorAll('[data-cc-hero-slider]').forEach(function(root){
    var slides=root.querySelectorAll('[data-cc-hero-slide]');
    var dots=root.querySelectorAll('[data-cc-hero-dot]');
    var live=root.querySelector('.cc-hero__slides');
    var nav=root.querySelector('[data-cc-hero-nav]');
    if(slides.length<2)return;
    var reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
    var cur=0,timer=null,hovered=false,focused=false,touched=false;
    function show(i){
      cur=(i+slides.length)%slides.length;
      slides.forEach(function(s,n){
        var on=n===cur;
        s.classList.toggle('is-active',on);
        if(on){s.removeAttribute('aria-hidden');s.removeAttribute('inert');}
        else{s.setAttribute('aria-hidden','true');s.setAttribute('inert','');}
      });
      dots.forEach(function(d,n){if(n===cur)d.setAttribute('aria-current','true');else d.removeAttribute('aria-current');});
    }
    function stop(){if(timer){clearInterval(timer);timer=null;}}
    function sync(){
      var run=!reduce.matches&&!hovered&&!focused&&!touched&&!document.hidden;
      live.setAttribute('aria-live',run?'off':'polite');
      if(run&&!timer)timer=setInterval(function(){show(cur+1);},5000);
      else if(!run)stop();
    }
    function go(i){show(i);stop();sync();}
    nav.removeAttribute('hidden');
    root.querySelector('[data-cc-hero-prev]').addEventListener('click',function(){go(cur-1);});
    root.querySelector('[data-cc-hero-next]').addEventListener('click',function(){go(cur+1);});
    dots.forEach(function(d){d.addEventListener('click',function(){go(+d.getAttribute('data-cc-hero-dot'));});});
    root.addEventListener('mouseenter',function(){hovered=true;sync();});
    root.addEventListener('mouseleave',function(){hovered=false;sync();});
    root.addEventListener('focusin',function(){focused=true;sync();});
    root.addEventListener('focusout',function(e){if(!root.contains(e.relatedTarget)){focused=false;sync();}});
    var x0=null,y0=null;
    root.addEventListener('touchstart',function(e){touched=true;sync();x0=e.touches[0].clientX;y0=e.touches[0].clientY;},{passive:true});
    root.addEventListener('touchend',function(e){
      if(x0===null)return;
      var dx=e.changedTouches[0].clientX-x0,dy=e.changedTouches[0].clientY-y0;
      x0=null;
      if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy))show(dx<0?cur+1:cur-1);
    },{passive:true});
    document.addEventListener('visibilitychange',sync);
    if(reduce.addEventListener)reduce.addEventListener('change',sync);
    sync();
  });
})();
